import React, {useEffect, useState} from 'react'
import {LoadingData} from '../../../components/LoadingData'
import {Pagination} from '../../../components/Pagination'
import {useAuth} from '../../modules/auth'
import {deleteFournisseurPOT, getReferentielsFournisseursPOT} from '../../../components/requests'
import {ModeleReferentielFournisseurPOT} from '../../../components/Models'
import {shouldDisplayFonctionnalite} from '../../../components/helpers'
import {useFormik} from 'formik'
import {Link} from 'react-router-dom'
import Swal from 'sweetalert2'
import {KTIcon} from '../../../_metronic/helpers'
import {Tooltip} from 'react-tooltip'

const ReferentielFournisseurPOTListPage = () => {
  const [dataReferentielFournisseurPOT, setDataReferentielFournisseurPOT] = useState<
    Array<ModeleReferentielFournisseurPOT>
  >([])
  const [loading, setLoading] = useState(false)
  const [nombreDePages, setNombreDePages] = useState<number>(0)
  const [totalPages, setTotalPages] = useState<number>(0)
  const [currentPage, setCurrentPage] = useState<number>(1)
  const [searchPage, setSearchPage] = useState<string>('')
  const [isSearch, setIsSearch] = useState(false)
  const [editHover, setEditHover] = useState<number | null>(null)
  const [deleteHover, setDeleteHover] = useState<number | null>(null)
  const {currentUser} = useAuth()

  useEffect(() => {
    getReferentielFournisseurPOTData()
  }, [currentPage, searchPage])

  const getReferentielFournisseurPOTData = () => {
    setLoading(true)
    getReferentielsFournisseursPOT(!isSearch ? currentPage : 1, searchPage)
      .then((referentielFournisseurPOTRequest) => {
        setNombreDePages(referentielFournisseurPOTRequest?.pages)
        setTotalPages(referentielFournisseurPOTRequest?.total)
        setCurrentPage(referentielFournisseurPOTRequest?.page)
        if (referentielFournisseurPOTRequest?.data !== undefined) {
          setDataReferentielFournisseurPOT(referentielFournisseurPOTRequest?.data)
          setLoading(false)
          setIsSearch(false)
        }
      })
      .catch((e) => {
        setLoading(false)
      })
  }

  const removeFournisseurPOT = async (fournisseurId) => {
    Swal.fire({
      title: 'Attention',
      text: 'Merci de confirmer la suppression',
      icon: 'warning',
      confirmButtonText: 'Confirmer',
      cancelButtonText: 'Annuler',
      showCancelButton: true,
      confirmButtonColor: '#1BC5BD',
      cancelButtonColor: '#F64E60',
    }).then((alertResult) => {
      if (alertResult.isConfirmed) {
        setLoading(true)
        deleteFournisseurPOT(fournisseurId).then((response) => {
          if (response?.status === 200) {
            setLoading(false)
            setDataReferentielFournisseurPOT((prev) => prev?.filter(
              (item) => item?.id !== fournisseurId
            ))
            // getReferentielFournisseurPOTData()
          }
        })
      }
    })
  }

  const formik = useFormik({
    initialValues: {search: ''},
    onSubmit: (values, {setSubmitting}) => {
      setTimeout(() => {
        setSearchPage(values.search)
      }, 1000)
    },
  })

  return (
    <>
      {/* begin::Row  */}
      <div className='row g-5 g-xl-8'>
        {/* begin::Col  */}
        <div className='col-xxl-12'>
          <div className={`card card-xxl-stretch mb-5 mb-xl-8`}>
            {/* begin::Header */}
            <div className='card-header border-0 pt-5 justify-content-end'>
              {shouldDisplayFonctionnalite(currentUser, 'AJOUTER FOURNISSEUR POT') && (
                <div
                  className='card-toolbar'
                  data-bs-toggle='tooltip'
                  data-bs-placement='top'
                  data-bs-trigger='hover'
                  title='Ajouter un fournisseur POT'
                >
                  <Link
                    to={`/referentiel-fournisseur-pot/ajouter`}
                    state={{
                      allFournisseursPOT: dataReferentielFournisseurPOT
                        ?.map((item) => item?.nom)
                    }}
                    className='btn btn-sm btn-light-primary'
                  >
                    <KTIcon iconName='plus' className='fs-3' />
                    Créer un fournisseur POT
                  </Link>
                </div>
              )}
            </div>
            {/* end::Header */}
            {/* debut champs recherche */}
            <form className='card-header border-0 pt-5 pb-5' onSubmit={formik.handleSubmit}>
              <div></div>
              <div className='form-group d-flex col-lg-4'>
                <div className='input-group'>
                  <input
                    type='text'
                    className='form-control h-100'
                    {...formik.getFieldProps('search')}
                    name='search'
                    placeholder='Rechercher un fournisseur'
                  />
                  <button
                    type='submit'
                    className='btn btn-light border-0 input-group-append h-100'
                    onClick={() => setIsSearch(true)}
                  >
                    <i className='fas fa-search text-secondary fs-1'></i>
                  </button>
                </div>
              </div>
            </form>
            {/* fin champs recherche */}

            {loading ? (
              <LoadingData />
            ) : (
              <>
                {shouldDisplayFonctionnalite(currentUser, 'VOIR FOURNISSEUR POT') && (
                  <div className='card-body py-3'>
                    {/* begin::Table container */}
                    <div className='table-responsive'>
                      {/* begin::Table */}
                      <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                        {/* begin::Table head */}
                        <thead>
                          <tr className='fw-bold text-muted'>
                            <th style={{width: '40%'}}>Nom</th>
                            <th style={{width: '50%'}}>Lien ou autres</th>
                            <th className='text-end' style={{width: '10%'}}>
                              Actions
                            </th>
                          </tr>
                        </thead>
                        {/* end::Table head */}
                        {/* begin::Table body */}
                        <tbody>
                          {dataReferentielFournisseurPOT.length ? (
                            dataReferentielFournisseurPOT.map((refFournisseurPOT, index) => {
                              return (
                                <tr key={refFournisseurPOT.id}>
                                  <td>
                                    <div className='d-flex align-items-center'>
                                      <div className='d-flex justify-content-start flex-column'>
                                        <p className='text-gray-800 fw-bold text-hover-primary fs-6 mb-0'>
                                          {refFournisseurPOT?.nom}
                                        </p>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <p className='text-gray-800 fw-bold text-hover-primary d-block fs-6 mb-0'>
                                      {refFournisseurPOT?.lien}
                                    </p>
                                  </td>
                                  <td>
                                    <div className='d-flex justify-content-end flex-shrink-0 gap-3'>
                                      <span
                                        className={`btn btn-icon btn-bg-light btn-sm ${
                                          shouldDisplayFonctionnalite(
                                            currentUser,
                                            'MODIFIER FOURNISSEUR POT'
                                          )
                                            ? ''
                                            : 'invisible'
                                        }`}
                                      >
                                        <Link
                                          to={`/referentiel-fournisseur-pot/${refFournisseurPOT?.id}/modifier`}
                                          state={{
                                            allFournisseursPOT: dataReferentielFournisseurPOT
                                              ?.map((item) => item?.nom)
                                              ?.filter((item) => item !== refFournisseurPOT?.nom?.trim())
                                          }}
                                        >
                                          <i
                                            key={refFournisseurPOT?.id}
                                            className='bi bi-pencil-square fs-2'
                                            style={{
                                              color: editHover === index ? '#ffcd3f' : '',
                                              transition: 'color 0.3s ease',
                                            }}
                                            onMouseEnter={() => setEditHover(index)}
                                            onMouseLeave={() => setEditHover(null)}
                                            data-tooltip-id='tooltip'
                                            data-tooltip-content='Modifier'
                                            data-tooltip-place='right'
                                          ></i>
                                        </Link>
                                      </span>
                                      <span
                                        className={`btn btn-icon btn-bg-light btn-sm ${
                                          shouldDisplayFonctionnalite(
                                            currentUser,
                                            'SUPPRIMER FOURNISSEUR POT'
                                          ) &&
                                          (refFournisseurPOT?.typePiecePOT
                                            ? refFournisseurPOT.typePiecePOT.length === 0
                                            : true)
                                            ? ''
                                            : 'invisible'
                                        }`}
                                      >
                                        <i
                                          key={refFournisseurPOT?.id}
                                          className='bi bi-trash fs-2'
                                          onClick={() =>
                                            removeFournisseurPOT(refFournisseurPOT?.id)
                                          }
                                          style={{
                                            color: deleteHover === index ? '#f1416c' : '',
                                            transition: 'color 0.3s ease',
                                          }}
                                          onMouseEnter={() => setDeleteHover(index)}
                                          onMouseLeave={() => setDeleteHover(null)}
                                          data-tooltip-id='tooltip'
                                          data-tooltip-content='Supprimer'
                                          data-tooltip-place='right'
                                        ></i>
                                      </span>
                                    </div>
                                  </td>
                                </tr>
                              )
                            })
                          ) : (
                            <tr>
                              <td colSpan={6} className='text-center'>
                                Aucun résultat trouvé
                              </td>
                            </tr>
                          )}
                        </tbody>
                        {/* end::Table body */}
                      </table>
                      {/* end::Table */}
                    </div>
                    {/* end::Table container */}

                    {/* begin::pagination*/}
                    <Pagination
                      totalPages={totalPages}
                      nombreDePages={nombreDePages}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                      locationState={0}
                    />
                    {/* end::pagination*/}
                    {/*Affichage du tooltip*/}
                    <Tooltip id='tooltip' />
                  </div>
                )}
              </>
            )}
          </div>
        </div>
        {/* end::Col  */}
      </div>
      {/* end::Row  */}
    </>
  )
}

export {ReferentielFournisseurPOTListPage}
